import React from 'react'
import { FormTypeCardContainer, FormTypeCount, FormTypeLabel, FormTypeName } from './style'

export interface FormTypeTileItem {
  value: string
  label: string
  count: number
}

export interface FormTypeCardProps {
  item: FormTypeTileItem
  isActive?: boolean
  onClick?: (value: string | null) => void
}

/** A single form-type tile: label + count, toggling the grid's form-type filter when clicked. */
export const FormTypeCard: React.FC<FormTypeCardProps> = React.memo(({ item, isActive, onClick }) => {
  const handleClick = () => {
    onClick?.(isActive ? null : item.value)
  }

  return (
    <FormTypeCardContainer type="button" aria-pressed={Boolean(isActive)} data-active={isActive} onClick={handleClick}>
      <FormTypeLabel>Form Type</FormTypeLabel>
      <FormTypeName>{item.label}</FormTypeName>
      <FormTypeCount>{item.count}</FormTypeCount>
    </FormTypeCardContainer>
  )
})
